import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import type { OperatorFeatures } from "../urls";
import urls from "../urls";
import type { OperatorListItem } from "../utils/backend-types";

type FetchOperatorsArgs = {
  project_id?: string;
  variant_id?: number;
  activeFeatures?: Array<OperatorFeatures>;
  withDetails?: boolean;
};

export function useOperators(
  args: FetchOperatorsArgs,
  options?: Partial<UseQueryOptions<Array<OperatorListItem>>>
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["operators", args],
    queryFn: () => fetchOperators(args),
    staleTime: 60_000, // 60 seconds
    ...options
  });

  return { data, isLoading, error };
}

async function fetchOperators(args: FetchOperatorsArgs) {
  const operatorsUrl = urls.apiWithoutCamelization.operators(args);
  const response =
    await apiWithoutCamelization.get<Array<OperatorListItem>>(operatorsUrl);
  return response.data;
}
